module.exports = __webpack_public_path__ + "static/assets/3c6f0be62f23f99a0f3a1dae2cc535d4.svg";